import { Action } from '@ngrx/store';

export enum DocumentActionTypes {
  DocumentPrintingDataRequested = '[Document] Document printing data requested',
  DocumentPrintingDataPrinted = '[Document] Document data printed',
  CounterAssistTicketDataRequested = '[Document] Counter Assist ticket data requested',
  PaymentReceiptDataRequested = '[Document] Payment Receipt data requested',
  PaymentReceiptDataPrinted = '[Document] Payment Receipt data printed',
  BagTagDataRequested = '[Document] Bag Tag data requested',
  BagTagDataPrinted = '[Document] Bag Tags printed',
  PrintCounterAssist = '[Document] Print Counter assist ticket',
}

export class DocumentPrintingDataRequested implements Action {
  readonly type = DocumentActionTypes.DocumentPrintingDataRequested;
}

export class DocumentPrintingDataPrinted implements Action {
  readonly type = DocumentActionTypes.DocumentPrintingDataPrinted;
}

export class CounterAssistTicketDataRequested implements Action {
  readonly type = DocumentActionTypes.CounterAssistTicketDataRequested;
  constructor(public payload: { alertReasonCode: string }) {}
}

export class PaymentReceiptDataPrinted implements Action {
  readonly type = DocumentActionTypes.PaymentReceiptDataPrinted;
}

export class PaymentReceiptDataRequested implements Action {
  readonly type = DocumentActionTypes.PaymentReceiptDataRequested;
}

export class BagTagDataRequested implements Action {
  readonly type = DocumentActionTypes.BagTagDataRequested;
}

export class BagTagDataPrinted implements Action {
  readonly type = DocumentActionTypes.BagTagDataPrinted;
}

export class PrintCounterAssist implements Action {
  readonly type = DocumentActionTypes.PrintCounterAssist;

  constructor(public payload?: { alertReasonCode: string; alertMessageCode: string }) {}
}

export type DocumentActions =
  | DocumentPrintingDataRequested
  | CounterAssistTicketDataRequested
  | PaymentReceiptDataRequested
  | PaymentReceiptDataPrinted
  | BagTagDataRequested
  | BagTagDataPrinted
  | PrintCounterAssist;
